//
// Template store
//

import * as client from 'api/client';
import { activity as activitySchema } from 'api/schema';
import { normalize } from 'normalizr';
import { LOGOUT } from './auth';

// ------------------------------------
// Constants
// ------------------------------------

export const NO_TEMPLATE = {
  id: 0,
  title: ''
};

// ------------------------------------
// Action definitions
// ------------------------------------

export const REQUEST_ACTIVITIES = 'ACTIVITIES/REQUEST';
export const RECEIVE_ACTIVITIES = 'ACTIVITIES/RECEIVE';

// ------------------------------------
// Actions
// ------------------------------------

export const fetchActivities = () => dispatch => {
  dispatch({ type: REQUEST_ACTIVITIES });

  return client.get('/api/public/activities')
    .then(json => {
      const { entities } = normalize(json, [ activitySchema ]);
      dispatch({
        type: RECEIVE_ACTIVITIES,
        activities: entities.activities
      });
    })
    .catch(console.error);
};

// ------------------------------------
// Initial state
// ------------------------------------

const initialState = {
  items: {},
  pending: false
};

// ------------------------------------
// Reducer
// ------------------------------------

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ACTIVITIES:
      return {
        ...state,
        pending: true
      };

    case RECEIVE_ACTIVITIES:
      return {
        ...state,
        items: action.activities,
        pending: false
      };

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

// ------------------------------------
// Utils
// ------------------------------------

export const getAllActivities = state => {
  return Object.values(state.activities.items ? state.activities.items : {});
};

export const getActivity = (state, id) => {
  const { items } = state.activities;
  return items.hasOwnProperty(id)
    ? { ...items[id] }
    : null;
};



// WEBPACK FOOTER //
// ./src/store/modules/activities.js